import React, { PureComponent } from 'react';
import { Input, Icon, Divider } from 'sup-ui';
import _ from 'lodash';
import classnames from 'classnames';
import { request } from 'sup-rc-utility';
import Highlighter from 'react-highlight-words';

const prefixCl = 'sup-rc-table-select-tag';

class SelectTag extends PureComponent {
  state = {
    active: false,
    inputValue: '',
    searchOptions: [],
  }

  componentDidMount() {
    window.addEventListener('click', this.checkActive);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { selectedKeys } = nextProps;
    // 最多输入5个
    if (selectedKeys.length >= 5) {
      return this.handleBlur();
    }
  }

  componentDidUpdate() {
    if (this.saveInputMirrorRef && this.input) {
      this.input.input.style.width = `${this.saveInputMirrorRef.offsetWidth + 10}px`;
    }
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.checkActive);
  }

  checkActive = (e) => {
    if (!['sup-rc-table-select-tag-selection', 'sup-rc-table-select-tag-placeholder', 'sup-input'].includes(e.target.className) && this.state.active) {
      this.handleBlur();
    } else {
      this.handleFocus();
    }
  }

  handleBlur = () => {
    this.input.blur();

    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }

    this.setState({
      active: false,
      inputValue: '',
      searchOptions: [],
    });
  }

  handleFocus = () => {
    const { selectedKeys } = this.props;

    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }

    if (selectedKeys.length >= 5) return;

    this.setState({
      active: true,
    }, () => {
      this.input.focus();
    });
  }

  // 输入搜索内容
  handleChangeValue = (e) => {
    const { value } = e.target;
    const { filterParams, item } = this.props;

    if (filterParams) {
      // 自定义属性
      const customParmas = filterParams.customParmas
        ? typeof filterParams.customParmas === 'function'
          ? filterParams.customParmas(item)
          : filterParams.customParmas
        : '';

      clearTimeout(this.timer);
      // 存在搜索内容，则搜索
      if (value) {
        this.timer = setTimeout(() => {
          request.get(`${filterParams.url}?${customParmas ? `${customParmas}&` : ''}${filterParams.param}=${encodeURIComponent(value)}`).then((res) => {
            const searchOptions = filterParams.callback(res);
            this.setState({
              searchOptions,
            });
          });
        }, 800);
      } else {
        this.setState({
          searchOptions: [],
        });
      }
    }

    this.setState({
      inputValue: value,
    });
  }

  // 选择搜索项
  handleSelectSearchItem = (value) => {
    const { setSelectedKeys, selectedKeys, onOk } = this.props;
    let newSelectedKeys = [];
    // 去前后空格
    const newValue = value ? value.replace(/(^\s*)|(\s*$)/g, '') : '';

    this.handleFocus();

    // 不输入搜索内容，直接回车，触发确认操作
    if (!newValue && onOk) {
      onOk();
    }

    // 已选中，则不能重复选择
    if (!newValue || selectedKeys.includes(newValue)) return;

    newSelectedKeys = selectedKeys.concat(newValue);
    setSelectedKeys(newSelectedKeys);

    // 清空搜索内容
    this.setState({
      inputValue: '',
    });

    this.handleUpdateHistory(newValue);
  }

  // 取消选中项
  handleDeselectSearchItem = (e, value) => {
    if (e) {
      e.stopPropagation();
    }

    const { setSelectedKeys, selectedKeys } = this.props;
    const newSelectedKeys = _.filter(selectedKeys, (o) => { return o !== value; });

    setSelectedKeys(newSelectedKeys);

    this.handleFocus();
  }

  // 清空
  handleClear = (e) => {
    if (e) {
      e.stopPropagation();
    }

    const { setSelectedKeys } = this.props;

    setSelectedKeys([]);

    this.setState({
      inputValue: '',
    });
  }

  // 更新hisoty
  handleUpdateHistory = (value) => {
    const searchValue = value || this.state.searchValue;
    const { item: { dataIndex }, tableKey } = this.props;
    const tableSearchHistory = JSON.parse(localStorage.getItem('tableSearchHistory')) || {};
    const historyOptions = tableSearchHistory?.[tableKey]?.[dataIndex] || [];

    if (searchValue) {
      if (!tableSearchHistory[tableKey]) {
        tableSearchHistory[tableKey] = {};
      }

      // 不存在该历史记录，则新增至第一位
      if (!historyOptions.includes(searchValue)) {
        historyOptions.unshift(searchValue);
      } else {
        // 已存在，则更新至第一位
        const index = historyOptions.indexOf(searchValue);
        historyOptions.splice(0, 0, ...historyOptions.splice(index, 1));
      }
      // 只保存前10个
      tableSearchHistory[tableKey][dataIndex] = historyOptions.slice(0, 10);
      localStorage.setItem('tableSearchHistory', JSON.stringify(tableSearchHistory));
    }
  }

  renderSelected = () => {
    const { selectedKeys = [] } = this.props;
    const { active, inputValue } = this.state;

    return (
      <ul
        className={`${prefixCl}-selection`}
        onClick={this.handleFocus}
      >
        {
          selectedKeys && selectedKeys.length !== 0
          && selectedKeys.map((tag, i) => {
            const key = `${tag}_${i}`;
            return (
              <li
                key={key}
                className={`${prefixCl}-tag`}
                onClick={(e) => e.stopPropagation()}
              >
                <span className={`${prefixCl}-label`} title={tag}>{tag}</span>
                <Icon
                  type="close-tag"
                  className={`${prefixCl}-close`}
                  onClick={(e) => this.handleDeselectSearchItem(e, tag)}
                />
              </li>
            );
          })
        }
        <li style={{ display: active ? 'block' : 'none', position: 'relative' }}>
          <Input
            size="small"
            ref={(ref) => { this.input = ref; }}
            className={`${prefixCl}-input`}
            value={inputValue}
            style={{
              width: 10,
            }}
            onChange={this.handleChangeValue}
            onPressEnter={(e) => this.handleSelectSearchItem(e.target.value)}
          />
          <span
            ref={(ref) => { this.saveInputMirrorRef = ref; }}
            className={`${prefixCl}-tempvalue`}
          >
            {inputValue}

          </span>
        </li>
        {
          (selectedKeys && selectedKeys.length !== 0) || inputValue ? (
            <Icon
              className={`${prefixCl}-icon`}
              type="error-circle"
              theme="filled"
              style={{
                color: 'rgba(53, 64, 82, 0.5)',
              }}
              onClick={this.handleClear}
            />
          ) : (
            <Icon className={`${prefixCl}-icon`} type="search" />
          )
        }
      </ul>
    );
  }

  renderList = () => {
    const { selectedKeys = [] } = this.props;
    const { inputValue, searchOptions } = this.state;
    const { item: { dataIndex }, tableKey, contextLocale } = this.props;
    const tableSearchHistory = JSON.parse(localStorage.getItem('tableSearchHistory'));
    const historyOptions = tableSearchHistory?.[tableKey]?.[dataIndex] || [];

    // 去重
    const newSearchOptions = [];
    searchOptions.forEach((value) => {
      if (newSearchOptions.includes(value)) return;
      newSearchOptions.push(value);
    });

    return (
      <div className={`${prefixCl}-list`}>
        <span className={`${prefixCl}-tip`}>
          {!inputValue ? contextLocale['SupTable.searchHistory'] : `${newSearchOptions ? newSearchOptions.length : 0}${contextLocale['SupTable.searchResult']}`}
        </span>
        <Divider className={`${this.props.prefixCl}-select-divider`} />
        {
          !inputValue ? (
            <ul className={`${prefixCl}-history`}>
              {
                historyOptions && historyOptions.length !== 0
                && historyOptions.map((value) => {
                  return (
                    <li
                      key={value}
                      className={`${prefixCl}-history-li`}
                      title={value}
                      onClick={() => this.handleSelectSearchItem(value)}
                    >
                      {value}
                    </li>
                  );
                })
              }
            </ul>
          ) : (
            <ul className={`${this.props.prefixCl}-select-ul`}>
              {
                newSearchOptions && newSearchOptions.length !== 0
                && newSearchOptions.map((item) => {
                  const liClassName = classnames(`${this.props.prefixCl}-select-li`, { [`${this.props.prefixCl}-action`]: selectedKeys.includes(item) });
                  return (
                    <li
                      key={item}
                      className={liClassName}
                      title={item}
                      onClick={() => this.handleSelectSearchItem(item)}
                    >
                      <Highlighter
                        highlightStyle={{ color: '#fa6400', backgroundColor: 'inherit' }}
                        searchWords={Array.isArray(inputValue) ? inputValue : [inputValue]}
                        autoEscape
                        textToHighlight={item.toString()}
                      />
                      <Icon className={`${this.props.prefixCl}-selected-icon`} type="check" theme="filled" />
                    </li>
                  );
                })
              }
            </ul>
          )
        }
      </div>
    );
  }

  render() {
    const { selectedKeys = [] } = this.props;
    const { inputValue } = this.state;
    const { item: { filterPlaceholder, title }, contextLocale } = this.props;

    return (
      <div className={`${prefixCl}`} onClick={this.checkActive}>
        {
          !inputValue && (!selectedKeys || !selectedKeys.length)
          && (
            <span
              className={`${prefixCl}-placeholder`}
              onClick={this.handleFocus}
            >
              {`${contextLocale['SupTable.pleaseInput']} ${filterPlaceholder || title}`}
            </span>
          )
        }
        {this.renderSelected()}
        {this.renderList()}
      </div>
    );
  }
}

export default SelectTag;
